import { Children, cloneElement, isValidElement, useId } from 'react';

export function FormField({ label, error, hint, required, children, style }) {
  const generatedId = useId();
  let controlId;
  const descriptionId = `${generatedId}-description`;
  const connectControl = nodes => Children.map(nodes, child => {
    if (!isValidElement(child) || controlId) return child;
    if (['input', 'select', 'textarea', TextInput, SelectInput, TextareaInput].includes(child.type)) {
      controlId = child.props.id || generatedId;
      return cloneElement(child, {
        id: controlId,
        'aria-invalid': error ? true : child.props['aria-invalid'],
        'aria-required': required || child.props['aria-required'],
        'aria-describedby': [child.props['aria-describedby'], (error || hint) && descriptionId].filter(Boolean).join(' ') || undefined,
      });
    }
    return child.props.children ? cloneElement(child, {}, connectControl(child.props.children)) : child;
  });
  const connectedChildren = connectControl(children);
  return (
    <div className="field" style={style}>
      {label && (
        <label className="label" htmlFor={controlId}>
          {label}
          {required && <span style={{ color: 'var(--danger)', marginLeft: 3 }}>*</span>}
        </label>
      )}
      {connectedChildren}
      {hint && !error && (
        <p id={descriptionId} style={{ fontSize: 'var(--text-xs)', color: 'var(--text-4)', marginTop: 4 }}>{hint}</p>
      )}
      {error && (
        <p id={descriptionId} style={{ fontSize: 'var(--text-xs)', color: 'var(--danger)', marginTop: 4 }}>{error}</p>
      )}
    </div>
  );
}

export function TextInput({ id, value, onChange, placeholder, type = 'text', disabled, min, max, step, autoComplete, ...accessibility }) {
  return (
    <input
      {...accessibility}
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      min={min}
      max={max}
      step={step}
      autoComplete={autoComplete}
      className="input"
    />
  );
}

export function SelectInput({ id, value, onChange, disabled, children, ...accessibility }) {
  return (
    <select {...accessibility} id={id} value={value} onChange={onChange} disabled={disabled} className="input">
      {children}
    </select>
  );
}

export function TextareaInput({ id, value, onChange, placeholder, rows = 3, disabled, ...accessibility }) {
  return (
    <textarea
      {...accessibility}
      id={id}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      disabled={disabled}
      className="input"
      style={{ resize: 'vertical', minHeight: 80 }}
    />
  );
}
